// extracted by mini-css-extract-plugin
module.exports = {"reportCard_img":"StatsCard_reportCard_img__PBxqD","reportCard_balance":"StatsCard_reportCard_balance__99Dyv","reportCard_main":"StatsCard_reportCard_main__3QycT"};